import { flattenValues } from "@uniformdev/canvas";

export interface UniformScrollableCardItem {
    scrollableCardLozengeText: string;
    scrollableCardLozengeColor:
        | "blue"
        | "saffron"
        | "lime"
        | "purple"
        | "neutral";
    scrollableCardTitle: string;
    scrollableCardUrl: {
        path: string;
        alt?: string;
    };
    scrollableCardAltText?: string;
    scrollableCardImage: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenScrollableCardProps = (props: any) => {
    return {
        ...props,
        scrollableCard: flattenValues(props.scrollableCard)
    };
};
